import { Component, HostBinding, Input, OnChanges } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import {
  resolveSideNavIconKey,
  SIDE_NAV_ICONS,
} from './side-nav-icons.registry';

@Component({
  selector: 'app-side-nav-icon',
  standalone: true,
  template: `
    <span
      class="side-nav-icon"
      [innerHTML]="svgHtml"
      aria-hidden="true"
    ></span>
  `,
  styles: [
    `
      :host {
        display: block;
        flex-shrink: 0;
        width: 2rem;
        height: 2rem;
      }

      .side-nav-icon {
        display: block;
        width: 100%;
        height: 100%;
        line-height: 0;
      }

      :host ::ng-deep svg {
        display: block;
        width: 100%;
        height: 100%;
      }

      :host ::ng-deep .p1 {
        fill: var(--ion-color-primary-icon);
      }

      :host ::ng-deep .p2 {
        fill: var(--ion-color-secondary-icon);
      }

      :host.side-nav-icon--inverted ::ng-deep .p1 {
        fill: var(--ion-color-secondary-icon);
      }

      :host.side-nav-icon--inverted ::ng-deep .p2 {
        fill: var(--ion-color-primary-icon);
      }
    `,
  ],
})
export class SideNavIconComponent implements OnChanges {
  @Input() svgPath = '';
  @Input() invertColors = false;

  @HostBinding('class.side-nav-icon--inverted')
  get hostInverted(): boolean {
    return this.invertColors;
  }

  svgHtml: SafeHtml = '';

  constructor(private sanitizer: DomSanitizer) {}

  ngOnChanges(): void {
    const key = resolveSideNavIconKey(this.svgPath);
    const def = SIDE_NAV_ICONS[key];
    if (!def) {
      this.svgHtml = '';
      return;
    }

    const markup = `<svg class="side-nav-icon__svg" viewBox="${def.viewBox}" xmlns="http://www.w3.org/2000/svg" focusable="false" aria-hidden="true">${def.inner.trim()}</svg>`;
    this.svgHtml = this.sanitizer.bypassSecurityTrustHtml(markup);
  }
}
